<template lang="pug">
  b-dropdown(no-flip)
    template(slot="button-content")
      label(v-if="selected") {{ placeholder }}
      h1 {{ title }}
    b-dropdown-form(v-if="data.length > limit")
      form(style="padding: 0 10px;")
        .form-group
          label {{ placeholder }}
          input.form-control(v-model="filter" placeholder="Filtrar` lista")
    b-dropdown-divider(v-if="data.length > limit")
    b-dropdown-item-button(v-if="showall" @click="select(null)") Todos
    b-dropdown-item-button(@click="select(row)" v-for="(row, index) in list" :key="index") {{ get_label(row) }}
</template>

<script>
export default {
  name: 'b-filter',
  props: ['items', 'value', 'placeholder', 'showall', 'defaultvalue', 'options'],
  data() {
    return {
      filter: null,
      limit: 25,
    }
  },
  computed: {
    data() {
        return this.$props.items || ((this.options || {}).data || [])
    },
    title() {
      return this.selected ? this.get_label(this.selected) : this.$props.placeholder
    },
    list() {
      let _list = this.filter && this.filter.length > 0 ? this.data.filter(item => {
        return item.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
      }) : this.data
      if (_list.length > this.limit) return _list.slice(0, this.limit)
      else return _list
    },
    selected() {
      return this.data.filter(row => this.compare(row, this.$props.value))[0]
    },
   _defaultvalue() {
        if (this.$props.defaultvalue && this.$props.defaultvalue.length > 0) {
            return this.$props.defaultvalue
        } else if (this.$props.options && this.$props.options.default && this.$props.options.default.length > 0) {
            return this.$props.options.default
        }
        return null
    }
  },
  methods: {
    is_active(data) {
      return this.compare(data, this.selected)
    },
    select(data) {
      this.$emit('input', this.get_value(data))
    },
    get_label(data) {
      return data instanceof Object ? data.name : data
    },
    get_value(data) {
      return data instanceof Object ? data.value : data
    },
    compare(lhs, rhs) {
      return this.compare_value(rhs, lhs) || this.compare_label(lhs, rhs)
    },
    compare_value(lhs, rhs) {
      lhs = `${this.get_value(lhs)}`.toLowerCase()
      rhs = `${this.get_value(rhs)}`.toLowerCase()
      return lhs == rhs
    },
    compare_label(lhs, rhs) {
      lhs = `${this.get_label(lhs)}`.toLowerCase()
      rhs = `${this.get_label(rhs)}`.toLowerCase()
      return lhs == rhs
    },
    reset() {
      let values = []

      if (this.$props.showall) return this.select(null)
      else if (this._defaultvalue) {
        values = this.data.filter(row => this.compare(row, this._defaultvalue))
      } else if (this.$props.value) {
        values = this.data.filter(row => this.compare(row, this.$props.value))
      }

      if (values.length > 0) this.select(values[0])
      else this.select(this.data[0])
    }
  },
  mounted() {
    this.reset()
  },
  ready() {
    this.reset()
  },
};
</script>


// WEBPACK FOOTER //
// filter.vue